import { Injectable } from '@angular/core'
import { IDateable } from '../../ui/components/date-selector/idateable.interface'
import { AbstractStorageKey, IDateableStorageKey, PreferenceStorageKey, StorageKey } from '../model/storage-key.model'

@Injectable({
    providedIn: 'root'
})
export class PpwLocalStorageService {
    readonly STORAGE_KEY_TIMECARD_TIMEFRAME = new IDateableStorageKey('STORAGE_KEY_TIMECARD_TIMEFRAME', true)
    readonly STORAGE_KEY_TIMESHEET_TIMEFRAME = new IDateableStorageKey('STORAGE_KEY_TIMESHEET_TIMEFRAME', true)
    readonly STORAGE_KEY_SELECTED_CLIENT_ID = new StorageKey<number>('STORAGE_KEY_SELECTED_CLIENT_ID', false)
    readonly STORAGE_KEY_SELECTED_EMPLOYEE_ID = new StorageKey<number>('STORAGE_KEY_SELECTED_EMPLOYEE_ID', false)
    readonly STORAGE_KEY_SELECTED_PROJECT_ID = new StorageKey<number>('STORAGE_KEY_SELECTED_PROJECT_ID', false)
    readonly STORAGE_KEY_SELECTED_USERACCOUNT_ID = new StorageKey<number>('STORAGE_KEY_SELECTED_USERACCOUNT_ID', false)
    readonly STORAGE_KEY_LANGUAGE: StorageKey<string> = new StorageKey<string>('STORAGE_KEY_LANGUAGE', true)
    readonly STORAGE_KEY_PROFILE_PREFERENCES = new PreferenceStorageKey('STORAGE_KEY_PROFILE_PREFERENCES', true)
    readonly STORAGE_KEY_VIEW_BY_TAG = new StorageKey<boolean>('STORAGE_KEY_VIEW_BY_TAG', false)

    storeData<T>(storageKey: AbstractStorageKey<T>, value: T): void {
        localStorage.setItem(storageKey.key, JSON.stringify(value))
    }

    getStoredData<T>(storageKey: AbstractStorageKey<T>): T | undefined {
        const jsonString = localStorage.getItem(storageKey.key)
        if (!jsonString) {
            return undefined
        }

        return storageKey.parseFromJSON(jsonString as string)
    }

    removeStoredData(key: string): void {
        localStorage.removeItem(key)
    }

    removeAllNonPersistentData(): void {
        const storedKeys: Array<keyof PpwLocalStorageService> = Object.keys(localStorage) as Array<
            keyof PpwLocalStorageService
        >
        storedKeys.forEach((key) => {
            if (this.keyCanBeRemoved(key)) {
                localStorage.removeItem(key)
            }
        })
    }

    private keyCanBeRemoved(key: keyof PpwLocalStorageService): boolean {
        const result: AbstractStorageKey<IDateable | number | string | boolean> = this[key] as AbstractStorageKey<
            IDateable | number | string | boolean
        >

        return !(result !== undefined && result.persistent)
    }
}
